<template>
  <div class="amount-util-wrap">
    <slot name="content">
      <div v-if="amount">{{ amount }}</div>
    </slot>
    <div class="amount-util ignore-rem" v-if="showAmountUtil">
      {{ amountUtil }}
    </div>
  </div>
</template>

<script>
/**
 *  本来是用base-guide-toast 但是每次都需要动态添加节点 所以弄个简单版本 也不支持这么多功能 后续有功能在加
 */
export default {
  name: 'amount-util',
  props: {
    amount: {
      type: [String, Number],
      default: null,
    },
    length: {
      // 默认十万才显示单位
      type: Number,
      default: 6,
    },
  },
  computed: {
    showAmountUtil() {
      return !!this.amountUtil;
    },
    amountUtil() {
      return this.COMMON.getAmountUtil(this.amount, this.length);
    },
  },
};
</script>

<style lang="scss">
.amount-util-wrap {
  position: relative;
  line-height: initial;
  .amount-util {
    position: relative;
    display: inline-block;
    background: #e1e8ef;
    color: #505564;
    box-shadow: none;
    text-align: center;
    border-radius: 8px;
    min-width: 96px;
    padding: 8px;
    box-sizing: border-box;
    font-size: 40px;
    line-height: 48px;
    margin-top: -48px;
    margin-left: -40px;
    font-weight: initial;
    transform-origin: bottom;
    transform: scale(0.5);
    &:before {
      position: absolute;
      content: '';
      width: 0;
      height: 0;
      left: 36px;
      border-bottom: 8px solid #e1e8ef;
      border-right: 8px solid transparent;
      border-left: 8px solid transparent;
      top: -8px;
      transform: scale(2);
    }
  }
}
</style>
